(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Concentric lithophone rings behind the hero stone
  var ringsCanvas = document.getElementById('rings');
  if (ringsCanvas) {
    var rctx = ringsCanvas.getContext('2d');
    var t = 0;
    (function drawRings() {
      var w = ringsCanvas.width, h = ringsCanvas.height, cx = w / 2, cy = h / 2;
      rctx.clearRect(0, 0, w, h);
      for (var i = 0; i < 6; i++) {
        var phase = reduce ? 0 : t * 0.006;
        var r = 60 + i * 70 + Math.sin(phase + i) * 8;
        rctx.beginPath();
        rctx.arc(cx, cy, r, 0, Math.PI * 2);
        rctx.strokeStyle = 'rgba(77,255,127,' + (0.22 - i * 0.03) + ')';
        rctx.lineWidth = 1.4;
        rctx.stroke();
      }
      if (!reduce) {
        t++;
        requestAnimationFrame(drawRings);
      }
    })();
  }

  // Strike waveform: click to replay a decaying sine
  var waveCanvas = document.getElementById('wave');
  if (waveCanvas) {
    var wctx = waveCanvas.getContext('2d');
    function drawWave(strikeT) {
      var w = waveCanvas.width, h = waveCanvas.height, mid = h / 2;
      wctx.clearRect(0, 0, w, h);
      wctx.strokeStyle = '#4dff7f';
      wctx.lineWidth = 2;
      wctx.beginPath();
      for (var x = 0; x < w; x++) {
        var decay = Math.exp(-x / (w * 0.28));
        var y = mid + Math.sin((x + strikeT) * 0.16) * 50 * decay;
        x === 0 ? wctx.moveTo(x, y) : wctx.lineTo(x, y);
      }
      wctx.stroke();
    }
    drawWave(0);
    if (!reduce) {
      waveCanvas.parentElement.style.cursor = 'pointer';
      waveCanvas.parentElement.addEventListener('click', function () {
        var start = null;
        function anim(ts) {
          if (!start) start = ts;
          var p = ts - start;
          drawWave(p * 0.3);
          if (p < 900) requestAnimationFrame(anim);
        }
        requestAnimationFrame(anim);
      });
    }
  }

  // Reveal box (lithophane off/on toggle): tap support alongside hover
  document.querySelectorAll('.reveal-box').forEach(function (box) {
    box.addEventListener('click', function () {
      box.classList.toggle('is-on');
    });
  });

  // Thumbnail swap on the featured-product gallery and the product page gallery
  [
    ['[data-feature-thumbs]', '#FeatureMainImage'],
    ['[data-product-thumbs]', '#MainProductImage']
  ].forEach(function (pair) {
    document.querySelectorAll(pair[0]).forEach(function (row) {
      var main = row.parentElement.querySelector(pair[1]);
      if (!main) return;
      row.querySelectorAll('.thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.dataset.full;
        });
      });
    });
  });

  // Product page: sync option selects to the real variant id + live price/availability
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsTag = form.querySelector('[data-product-variants]');
    if (!variantsTag) return;
    var variants;
    try {
      variants = JSON.parse(variantsTag.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('.variant-id-input');
    var priceEl = form.querySelector('.js-price');
    var compareEl = form.querySelector('.js-compare');
    var submitBtn = form.querySelector('.js-submit');
    var optionSelects = form.querySelectorAll('.option-select');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      var chosen = Array.prototype.map.call(optionSelects, function (s) {
        return s.value;
      });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === chosen[i];
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        applyVariant(findVariant());
      });
    });
  });
})();
